var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/autosuggest-emoji.tsx";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import unicodeMapping from 'soapbox/features/emoji/emoji-unicode-mapping-light';
import { joinPublicPath } from 'soapbox/utils/static';

const AutosuggestEmoji = _ref => {
  let {
    emoji
  } = _ref;
  let url;

  if (emoji.custom) {
    url = emoji.imageUrl;
  } else {
    // @ts-ignore
    const mapping = unicodeMapping[emoji.native] || unicodeMapping[emoji.native.replace(/\uFE0F$/, '')];

    if (!mapping) {
      return null;
    }

    url = joinPublicPath("packs/emoji/".concat(mapping.filename, ".svg"));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "autosuggest-emoji",
    "data-testid": "emoji",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "emojione",
    src: url,
    alt: emoji.native || emoji.colons,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }), emoji.colons);
};

export default AutosuggestEmoji;